import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSummary } from "../service/summary.service";

export const fetchSummary = createAsyncThunk(
  "summary/fetchSummary",
  async (checkoutId, { rejectWithValue }) => {
    try {
      const response = await getSummary(checkoutId);
      return response.data;
    } catch(error){
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

const summarySlice = createSlice({
  name:"summary",
  initialState:{
    loading:false,
    summary:null,
    error:null
  },
  reducers:{},
  extraReducers:(builder)=>{
    builder
    .addCase(fetchSummary.pending,(state)=>{
      state.loading=true;
      state.error=null;
    })


  .addCase(fetchSummary.fulfilled,(state,action)=>{
    state.loading=false;
    state.summary=action.payload;
  })


  .addCase(fetchSummary.rejected,(state,action)=>{
    state.loading=false;
    state.error=action.payload;

  });
  }
});
export default summarySlice.reducer;